import EnhancedTab from 'lib/designSystem/TabSimulation';
import { hasAnySettingsAuditLogsPermissions } from 'lib/permissionChecks/settings';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { AuthState } from 'services/redux/authSlice';

import AuditLogs from './AuditLogs';

const allTabs = [
  {
    label: 'Logs',
    component: <AuditLogs />,
    path: 'logs',
    hasPermission: hasAnySettingsAuditLogsPermissions,
  },
];

const OthersSettings: React.FC = () => {
  const navigate = useNavigate();
  const { subPage } = useParams<{ page: string; subPage: string }>();
  const [startValue, setStartValue] = useState(0);
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);

  const tabs = useMemo(
    () => allTabs.filter((tab) => tab.hasPermission(user)),
    [user],
  );

  const handleNavigation = (index: number) => {
    if (tabs[index]) {
      navigate(`/settings/others/${tabs[index].path}`);
    }
  };

  useEffect(() => {
    let subPageIndex = tabs.findIndex((x: any) => x.path === subPage);
    subPageIndex = subPageIndex === -1 ? 0 : subPageIndex;
    handleNavigation(subPageIndex);
    setStartValue(subPageIndex);
  }, [tabs]);

  if (tabs.length === 0) return null;

  return (
    <div>
      <EnhancedTab
        startValue={startValue}
        tabs={tabs}
        onTabChange={handleNavigation}
      />
    </div>
  );
};

export default OthersSettings;
